// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CodeTwoToneSvg from "@fishx/icons-svg/es/asn/CodeTwoTone";
import FishxIcon from '../components/FishxIcon';

var CodeTwoTone = function CodeTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CodeTwoToneSvg
  }));
};

CodeTwoTone.displayName = 'CodeTwoTone';
export default React.forwardRef(CodeTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CodeTwoTone.js
// module id = 2271
// module chunks = 0